<footer class="footer is-relative">
	<div class="container">
		<div class="columns">
			<div class="column">
				<div class="columns is-multiline">
					<!-- Dirección Estado de México -->
					<div class="column">
						<h5 [class.is-marginless]="showEmailSubs" class="has-text-centered title is-5 border-red">Estado de México</h5>
		
						<a *ngIf="showEmailSubs" class="title is-6 has-text-centered is-block red" href="mailto: ventas.calibracion@cccisa.com.mx" style="font-size: 0.9em">
							ventas.calibracion@cccisa.com.mx
						</a>
		
						<div class="columns is-gapless">
							<div class="column">
								<a style="color: black" href="https://www.google.com/maps/place/Centro+de+Calibraci%C3%B3n+y+Capacitaci%C3%B3n+Industrial+S.A.+de+C.V.+CCCISA/@19.5526369,-99.2153165,17z/data=!3m1!4b1!4m5!3m4!1s0x85d21d14a38ef1fd:0xc7e78eb0e8c39b2b!8m2!3d19.5526319!4d-99.2131278">
									Calle La Paz #233, Fracc. Valle Dorado Tlalnepantla de Baz, Estado de Mex. CP 54020
								</a>
							</div>
							<div class="column is-flex phone-column">
								<a class="title black is-block is-6 is-marginless has-text-centered" href="tel:+525553885638">(55) 53 88 56 38</a>
							</div>
						</div>
					</div>
					


					<div *ngIf="!showEmailSubs" class="column is-full">
						<a href="mailto:ventas.sh@cccisa.com.mx" class="title is-5 red has-text-centered">ventas.sh@cccisa.com.mx</a>
					</div>
				</div>
			</div>


			<!-- Email CCCISA -->
			<div class="column is-flex is-narrow" style="align-items: center; justify-content: center">
				<a class="title is-4 blue" href="mailto: cccisa@cccisa.com.mx">cccisa@cccisa.com.mx</a>
			</div>

			<!-- Redes -->
			<div class="column is-narrow is-flex" style="align-items: center; justify-content: center">
				<a href="https://twitter.com/LABCCCISA">
					<img src="/assets/img/twitter.svg" style="height: 50px"/>
				</a>
			</div>

			<div class="column is-narrow is-flex" style="align-items: center; justify-content: center">
				<a href="#">
					<img src="/assets/img/linked.svg" style="height: 50px"/>
				</a>
			</div>
		</div>
	</div>
</footer>